const exposeComponentOnData = (host, componentRef) => {
  $(host).data('ReactComponent', componentRef);
};

export default exposeComponentOnData;
